import axios from "axios";
import { useEffect } from "react";
import { baseURL } from "../../globals/constants";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearUserInfo, clearUserToken } from "../../redux/slices/AuthenticationSlice";
import { AppDispatch } from "../../redux/store";

const Logout=() =>{
    const navigate=useNavigate();
    const dispatch:AppDispatch=useDispatch();
    const clearData=()=>{
        dispatch(clearUserInfo(''));
        dispatch(clearUserToken(''));
        // End the session on the server too, so the refresh token can't be used again
        const refreshToken = localStorage.getItem('refresh_token')
        if (refreshToken) {
            axios.post(`${baseURL}/v1/auth/logout`, { refreshToken }).catch(() => undefined)
        }
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('role')
        localStorage.removeItem('user')
    }
    useEffect(()=>{
        clearData();
        navigate('/');
    },[clearData])

  return (
    <div>Logout</div>
  )
}
export default Logout;
